var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stripe-card-edit"},[_c('stripe-new-card',{ref:"stripeNewCard",attrs:{"signup":true},on:{"confirm":_vm.confirm,"cancel":_vm.cancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }